var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-basic p-home"},[_c('div',{staticClass:"messageDialog"})])
}]

export { render, staticRenderFns }